// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store/store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import { Message } from "element-ui";
import { Loading } from "element-ui";
import api from "./api/api";
import utilFn from "./api/util";
import "../static/icon/iconfont.css";
import "../static/icon2/iconfont.css";
import "../static/icon3/iconfont.css";

import "../static/css/template.css";
import ElTreeSelect from "el-tree-select";
import utils from "../static/js/utils";
import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import VideoPlayer from "vue-video-player";
import EasyUI from "vx-easyui";
import VueDND from "awe-dnd";
import VueClipboard from "vue-clipboard2";
import Print from "vue-print-nb";

//版本迭代提醒
import "../static/js/versionControl.js";
//自定义指令
import Permission from "../static/js/permission.js";
Vue.use(Permission);
require("video.js/dist/video-js.css");
require("vue-video-player/src/custom-theme.css");

VueClipboard.config.autoSetContainer = true;
import moment from "moment";
Vue.prototype.$moment = moment;
Vue.use(VueClipboard);
Vue.use(VueDND);
Vue.use(EasyUI);
Vue.use(VideoPlayer);
Vue.use(VueQuillEditor);
Vue.use(ElementUI);
Vue.use(ElTreeSelect);
Vue.use(utils);
Vue.use(Print);

Vue.use(ElementUI, { size: "small" });
Vue.config.productionTip = false;
require("../static/css/style.css");
Vue.prototype.$message = Message;
Vue.prototype.$loading = Loading;
Vue.prototype.api = api;
Vue.prototype.util = utilFn;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: {
    App,
    api
  },
  template: "<App/>",
  render: h => h(App)
});

// var Less = require('Less');



// WEBPACK FOOTER //
// ./src/main.js